/* @flow weak */

const _ = require('lodash');
const Reflux = require('reflux');
const SKUActions = require('../actions/SKUActions.jsx');

const SKUStore = Reflux.createStore({
  listenables: [SKUActions],

  data: {},

  getInitialState() {
    return this.data;
  },

  onLoad(data) {
    this.data = data;

    this.trigger(this.data);
  },

  getSKUPricing() {
    return this.data;
  }
});

module.exports = SKUStore;


// WEBPACK FOOTER //
// ./src/base/scripts/stores/SKUStore.jsx